import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { formatTagBsk, getBskList, getIdList } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-tagbsk',
    templateUrl: './edit-tagbsk.component.html',
    styleUrls: ['./edit-tagbsk.component.scss'],
})
export class EditTagBskComponent implements OnInit {
    public selectedRequest: any;
    public requestResult: any[];

    @Input()
    public item: any;

    @Input()
    public tagList = [];

    @Input()
    public basketList = [];


    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.selectedRequest = new Object();
        this.selectedRequest.notifyParent = new EventEmitter(); 
    }

    ngOnInit() {
        this.getRequest(this.item.reference);
        this.commonService.checkReset();
    }


    private async getRequest(id) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('gettagbasket', id ));
            this.requestResult = wRes.data;
            this.resetReq();
            if (id !== 0) {
                this.loadRequestData(this.requestResult);
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private loadRequestData(adata) {
        this.selectedRequest.id = adata[0].id_base;
        this.selectedRequest.id_request = adata[0].id_base;
        this.selectedRequest.tagList = [];
        this.selectedRequest.tagList.push(adata[0].id_base);
        this.selectedRequest.basketList = [...getBskList(adata)];
        this.selectedRequest.idList = [...getIdList(adata)];
        this.selectedRequest._label = this.item._label;
        this.selectedRequest.notifyParent.emit();
    }

    private resetReq() {
        this.selectedRequest.id = 0;
        this.selectedRequest.id_request = 0;
        this.selectedRequest.tagList = [];
        this.selectedRequest.basketList = [];
        this.selectedRequest.idList = [];
        this.selectedRequest._label = '';
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data, item: this.item });
    }

    public async validate (request) {
        let wRes: any = {};
        try {
            const wdata = formatTagBsk(request, request.id, this.selectedRequest.idList);
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatetagbsk', wdata));
            this.onValidate.emit({ data: wRes.data, index: this.item.index, id: this.item.id, create: false });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
